import script from "./PayDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PayDialog.vue?vue&type=script&setup=true&lang=js"

import "./PayDialog.vue?vue&type=style&index=0&id=9ae20986&scoped=true&lang=less"
import "./PayDialog.vue?vue&type=style&index=1&id=9ae20986&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ae20986"]])

export default __exports__